import { render } from "./Column.vue?vue&type=template&id=33eed531&scoped=true"
import script from "./Column.vue?vue&type=script&lang=js"
export * from "./Column.vue?vue&type=script&lang=js"

import "./Column.vue?vue&type=style&index=0&id=33eed531&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33eed531"

export default script